import React from "react";
import {
  RightSidebar,
  RightSidebarHeader,
  RightSidebarContent,
  RightSidebarSaveFooter
} from "../RightSidebar";
import styles from "./PaymentSidebar.module.scss";
import { Alert } from "@blueprintjs/core";
import { Icon } from "../../atoms/Icon";
import { PaymentForm } from "./PaymentForm";
import usePaymentSidebar from "./PaymentSidebarHooks";

function PaymentSidebar({ onDismiss, sidebarIsOpen = true }) {
  const {
    isAlertOpen,
    onAlertCancel,
    onAlertConfirm,
    //   onSave,
    onDismissSidebar,
    isFormValid,
    loading,
    onSubmit,
    ...paymentSidebarProps
  } = usePaymentSidebar({
    onDismiss
  });

  return (
    <>
      <Alert
        className={styles.confirmAlert}
        cancelButtonText="Cancel"
        confirmButtonText="Yes, don't save"
        icon={
          <Icon
            name="warning-sign"
            color="#7a869b"
            size={32}
            className={styles.confirmAlertIcon}
          />
        }
        intent="danger"
        isOpen={isAlertOpen}
        onCancel={onAlertCancel}
        onConfirm={onAlertConfirm}
        canEscapeKeyCancel
        canOutsideClickCancel
      >
        <p className={styles.confirmAlertMessage}>
          Are you sure you want to dismiss without saving? All your changes will
          be lost.
        </p>
      </Alert>
      <RightSidebar sidebarIsOpen={sidebarIsOpen}>
        <RightSidebarHeader
          title="Add Credit Card"
          onDismiss={onDismissSidebar}
          isDismissDisabled={loading}
        />

        <RightSidebarContent>
          <PaymentForm {...paymentSidebarProps} />
        </RightSidebarContent>

        <RightSidebarSaveFooter
          onCancel={onDismissSidebar}
          onSave={onSubmit}
          pageIsLoading={loading}
          disableSave={!isFormValid}
        />
      </RightSidebar>
    </>
  );
}

export default PaymentSidebar;
